<template>
<div class="mx-3">

    <delete-confirmation name="RMS document" @confirm="deleteDocument"></delete-confirmation>
    <rms-document-assign-modal :refresh="refresh"></rms-document-assign-modal>

    <div class="row mx-1">
        <div class="h2">RMS Documents</div>
        <div class="btn-group ml-auto mb-2" role="toolbar" aria-label="Toolbar">
            
        </div>
    </div>
    <div v-if="isLoading" class="pt-3 border-top">            
        <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
    </div>           
    <div v-else-if="documents.length" class="table-responsive">
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>Imported</th>
                    <th>Provider ID</th>                       
                    <th>Deposit Date</th>
                    <th>Document Type</th>
                    <th>Patient Name</th>
                    <th>Payer</th>
                    <th class="text-right">Payment Amount</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="document in documents" :key="'rms-documents-' + document.id">
                    <td>{{ document.created_at }}</td>
                    <td>{{ document.financing_provider_code }}</td>
                    <td>{{ document.deposit_date }}</td>
                    <td>{{ document.rms_document_type.name }}</td>
                    <td>{{ document.patient_name }}</td>
                    <td>{{ document.rms_payer_name }}</td>
                    <td class="text-right">{{ document.rms_document_total }}</td>
                    <td class="text-right">
                        <a class="mr-3" :href="'/rms/documents/' + document.id" target="_blank" title="View Document"><i class="fas fa-external-link-alt fa-lg"></i></a>
                        <a class="mr-3" href="javascript:void(0)" @click="linkDocument(document.id)" title="Link Document"><i class="fas fa-link fa-lg"></i></a>
                        <a class="mr-3" href="javascript:void(0)" @click="confirmDelete(document.id)" title="Delete Document"><i class="fas fa-trash-alt fa-lg"></i></a>
                    </td>
                </tr>               
            </tbody>
        </table>

        <div class="d-flex">
            <nav v-if="pageCount > 1" aria-label="Page navigation">
                <ul class="pagination">
                    <li v-bind:class="['page-item', { 'disabled' : currentPage == 1 }]">
                        <a class="page-link" href="#" @click="first()">
                            <span id="first-page"><i class="fas fa-step-backward fa-xs chev-pos"></i></span>
                        </a>
                    </li>                        
                    <li v-bind:class="['page-item', { 'disabled' : currentPage == 1 }]">
                        <a class="page-link" href="#" @click="previous()">
                            <span id="previous"><i class="fas fa-chevron-left fa-xs chev-pos"></i><i class="fas fa-chevron-left fa-xs mr-1 chev-pos"></i>Previous</span>
                        </a>
                    </li>
                    <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                        <a class="page-link" href="#" @click="next()">
                            <span id="next">Next<i class="fas fa-chevron-right fa-xs ml-2 chev-pos"></i><i class="fas fa-chevron-right fa-xs chev-pos"></i></span>
                        </a>
                    </li>
                    <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                        <a class="page-link" href="#" @click="last()">
                            <span id="first-page"><i class="fas fa-step-forward fa-xs chev-pos"></i></span>
                        </a>
                    </li>                        
                </ul>
            </nav>
            <div class="ml-auto"> Page {{ currentPage }} of {{ pageCount }}</div>
        </div>

    </div>
    <div v-else class="pt-3 border-top">
        <h2 class="text-muted text-center">No unlinked RMS documents.</h2>
    </div>    
</div>    
</template>

<script>
import RmsDocumentAssignModal from './RmsDocumentAssignComponent.vue';

export default {
    components: {
        RmsDocumentAssignModal
    },
    props: {
        page: Number
    },
    data() {
        return {
            documents: [],
            isLoading: true,
            pageCount: 0,
            currentPage: 1
        }
    },
    methods: {
        refresh: function () {
            this.isLoading = true;
            axios.get('/ajax/rms/documents', {
                params: {
                    'page': this.currentPage - 1
                }
            })
            .then(response => {
                this.documents = response.data.documents;
                this.pageCount = response.data.page_count;
                this.isLoading = false;
            })
            .catch(error => {
                console.log('got an error...');
                this.isLoading = false;
            });
        },
        first: function () {
            if (this.currentPage > 1) {
                this.currentPage = 1;
                this.refresh();
            }
        },        
        previous: function() {
            if (this.currentPage > 0) {
                this.currentPage--;
                this.refresh();
            }
        },
        next: function() {
            if (this.currentPage < this.pageCount) {
                this.currentPage++;
                this.refresh();
            }
        },
        last: function () {
            if (this.currentPage < this.pageCount) {
                this.currentPage = this.pageCount;
                this.refresh();
            }
        },
        linkDocument: function (id) {
            eventHub.$emit('show-rms-document-assign', id);
        },
        confirmDelete: function (id) {
            eventHub.$emit('show-delete-rms-document-confirmation', id);
        },          
        deleteDocument: function (id) {

            axios.delete('/ajax/rms/documents/' + id)
                .then(response => {
                    this.refresh();
                })
                .catch(error => {
                    console.log(error);
                    // let title = error.response.data.title;
                    // let message = error.response.data.message;
                    // let level = error.response.data.level;
                    // toastr[level](message, title, {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                });
        }
    },
    created() {
        this.refresh();
    }    
}
</script>

<style scoped>

</style>